import consumer from "./consumer"
import $ from 'jquery'

consumer.subscriptions.create({ channel: "UserNotificationChannel" }, {
  received(data) {
    $('#notification_dropdown').trigger('refresh')
  }
})
